export default "__VITE_ASSET__BZbFjmTT__"